module.exports = __webpack_public_path__ + "img/Abfahrk_pers_Daten.15a2b115.svg";